export const currentPasswordInputText = {
  label: 'Digite a sua senha atual',
  arialabel: 'Digite a sua senha atual',
  errorMessage: {
    emptyPassword: 'Campo obrigatório. Preencha sua senha.',
    passwordMismatch: 'Senha incorreta',
  },
}

export const formContexts = {
  ChangePassword: 'ChangePassword',
  ForgotPassword: 'ForgotPassword',
  NewDeviceChangePassword: 'NewDeviceChangePassword',
}

export const newPasswordInputText = {
  [formContexts.ChangePassword]: {
    label: 'Digite sua nova senha',
  },
  [formContexts.ForgotPassword]: {
    label: 'Crie uma nova senha',
  },
  [formContexts.NewDeviceChangePassword]: {
    label: 'Crie uma nova senha',
  },
  errorMessage: 'Senha utilizada recentemente. Por segurança, escolha outra.',
}

export const passwordConfirmInputText = {
  arialabel: 'Digite novamente sua senha',
  label: 'Confirmar a nova senha',
  errorMessage: 'As senhas estão diferentes. Tente novamente.',
}

export const BUTTON_TEXT = 'Alterar senha'

export const isTheSamePassword = (password, passwordConfirmation) =>
  password === passwordConfirmation
